import PriceEdit from "./PriceEdit";
import axios from "axios";
import { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { VscSave } from "react-icons/vsc";
import { useSelector } from "react-redux";
import { stockHeaders } from "./tableItems";
import config from "../../config";
import loadingImg from "../../assets/loading.gif"

const StockEdit = () => {

    const email1 = useSelector((state) => state.user.email);
    const [stocks, setStocks] = useState([])
    const [err, setErr] = useState("")
    const [selectedId, setSelectedId] = useState(null)
    const [editOn, seteditOn] = useState(false)
    const [index, setindex] = useState(null)
    const currentDate = new Date();
    const [date, setDate] = useState();
    const [refresh, setRefresh] = useState(false)
    const [isloading, setIsloading] = useState(false)
    const [currentPage, setCurrentPage] = useState(0)
    const [rows, setRows] = useState(5)
    const [totalPages, setTotalPages] = useState(0)

    const [inputs, setInputs] = useState({
        email: email1,
    })
    // get stocks list --
    useEffect(() => {
        getStocks()
    }, [rows])

   

    // get stocks list function
    const getStocks = async (e) => {

        try {
            const res = await axios.get(config.BL_API_URL + "/stock/v1/stockforPriceUpdate")


            if (res.data){

                setStocks(res.data)
                const totalPages = Math.ceil(res.data.length / rows)
                setCurrentPage(1)
                setTotalPages(totalPages)
                console.log(rows, currentPage, totalPages, stocks.length)
            }
            else
                setErr("backend error")

        } catch (err) {
            setErr("Server error...");
            if (err?.response?.data) setErr(err.response.data);
        }
    }

    const refreshBasketStockPrices = async (e) => {

        try {
            setRefresh(true);
            setIsloading(true)
            setErr("");
            setDate()
            const res = await axios.get(config.BL_API_URL + "/basketstock/v1/refreshBasketStockPrices")
            setIsloading(false);
            setDate(currentDate.toLocaleString());
            getStocks()
            if (res.status === 200 && res?.data?.messages?.length <= 1) {
                //getStocks()
            }
            else {
                setErr(res.data.messages)
            }

        } catch (err) {
            setErr("Server error on refresh..." + err);
            if (err?.response?.data) setErr(err.response.data);
        }
    }

    const handlePrev = () => {
        if (currentPage > 1)
            setCurrentPage(currentPage - 1)
    }

    const handleNext = () => {
        if (currentPage < totalPages)
            setCurrentPage(currentPage + 1)
    }

    return (
        <div className="my-12 md:px-14 p-4 max-w-screen-2xl mx-auto">
            <div className="flex flex-col">
                <div className="-m-1.5 overflow-x-auto">
                    <div className="border rounded-lg divide-y divide-gray-200 py-5">
                        {/* Navigation bar with title, refresh button, and pagination */}
                        <div className="col-span-10">
                            <div className="col-span-1">
                                <div className="flex justify-between items-center px-1 py-2">
                                    <div className="flex items-center gap-4">
                                        <span className="text-gray-500 text-lg font-bold">Stock Price Edit For test purpose only!</span>
                                    </div>
                                    <div className="flex items-center gap-4">
                                        <div className="flex items-center gap-2">
                                            <label className="text-xs text-gray-500">Rows per page:</label>
                                            <select
                                                value={rows}
                                                onChange={(e) => setRows(Number(e.target.value))}
                                                className="py-1 px-2 text-xs border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                            >
                                                <option value={5}>5</option>
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </div>
                                        <span className="text-sm font-normal text-gray-500">
                                            Showing <span className="font-semibold text-gray-900">{(currentPage - 1) * rows + 1}-{parseInt(((currentPage - 1) * rows) + rows) < stocks.length ? parseInt(((currentPage - 1) * rows) + rows) : stocks.length}</span>
                                            &nbsp;of <span className="font-semibold text-gray-900">{stocks.length}</span>
                                        </span>
                                        <ul className="inline-flex -space-x-px rtl:space-x-reverse text-sm">
                                            <li>
                                                <span onClick={e => handlePrev()} className="flex items-center justify-center px-3 py-2 ms-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 cursor-pointer">Prev</span>
                                            </li>
                                            <li>
                                                <span onClick={e => handleNext()} className="flex items-center justify-center px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 cursor-pointer">Next</span>
                                            </li>
                                        </ul>
                                        <button className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ${isloading ? 'bg-gray-500 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-700 text-white'}`} onClick={refreshBasketStockPrices}>
                                            Refresh
                                        </button>
                                        {isloading &&
                                            <img src={loadingImg} alt="Icon" className="w-6" />
                                        }
                                        {refresh && (
                                            <span className="text-gray-500 text-sm font-medium">Last refresh: {date}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="overflow-hidden">
                            <div className="max-h-96 overflow-y-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-200 sticky top-0 z-10">
                                        <tr>
                                            {stockHeaders.map((stockHeaderItem, index) => (
                                                <th key={index} scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase font-bold bg-gray-200">{stockHeaderItem.name}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stocks &&
                                            stocks.
                                            slice(((currentPage - 1) * rows), parseInt(((currentPage - 1) * rows) + rows)).
                                                map((list, index) => (
                                                    <tr key={index} className="odd:bg-white even:bg-gray-100 hover:bg-gray-300">
                                                        <PriceEdit list={list} />
                                                    </tr>
                                                ))}
                                        {(stocks === null || stocks.length <= 0) &&
                                            <tr><td colSpan={stockHeaders.length} className="text-center text-red-500">No records to display!</td></tr>
                                        }
                                        <tr><td colSpan={stockHeaders.length} className="text-center text-red-500">{err}</td></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StockEdit